export default function ZoomControls({ onZoomIn, onZoomOut, onFitToView }) {
  const btnClass =
    'w-9 h-9 bg-white border border-gray-300 rounded shadow-sm flex items-center justify-center text-lg font-bold text-gray-700 hover:bg-gray-100 active:bg-gray-200 select-none';

  return (
    <div className="absolute bottom-3 right-3 flex flex-col gap-1.5 z-10">
      <button className={btnClass} onClick={onZoomIn} title="Zoom in">
        +
      </button>
      <button className={btnClass} onClick={onZoomOut} title="Zoom out">
        &minus;
      </button>
      <button className={btnClass} onClick={onFitToView} title="Fit to view">
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="15 3 21 3 21 9" />
          <polyline points="9 21 3 21 3 15" />
          <line x1="21" y1="3" x2="14" y2="10" />
          <line x1="3" y1="21" x2="10" y2="14" />
        </svg>
      </button>
    </div>
  );
}
